import React from "react";
import emptyImage from "../../../assets/empty.svg";
import { Link } from "react-router-dom";

const NoTransaction = () => {
  return (
    <div className="flex justify-center items-center">
      <div>
        <img src={emptyImage} alt="No transfers" />
        <p className="mt-6 font-medium text-2xl text-center">You have no transfers</p>
        <div className="mt-6 flex justify-center">
          <Link
            to="/Add-transaction"
            className="px-6 py-2 bg-[#246eaa] text-white rounded-md text-lg font-medium"
          >
            Send Money
          </Link>
          </div>
      </div>
    </div>
  );
};

export default NoTransaction;
